const BOOKS_PENDING = 'books_pending';
const BOOKS_FAILED = 'books_failed';
const BOOKS_DOWNLOADED = 'books_downloaded';
const BOOK_DOWNLOADED = 'book_downloaded';
const BOOK_REMOVED = 'book_removed';
const BOOK_SENDING = 'book_sending';

export {
  BOOKS_PENDING,
  BOOKS_FAILED,
  BOOKS_DOWNLOADED,
  BOOK_DOWNLOADED,
  BOOK_REMOVED,
  BOOK_SENDING,
};



// WEBPACK FOOTER //
// ./src/store/books/types.js